import { render, staticRenderFns } from "./TeamModal.vue?vue&type=template&id=0c8a1382"
import script from "./TeamModal.vue?vue&type=script&lang=js"
export * from "./TeamModal.vue?vue&type=script&lang=js"
import style0 from "./TeamModal.vue?vue&type=style&index=0&id=0c8a1382&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports